import { render, staticRenderFns } from "./TotpVerify.vue?vue&type=template&id=7b665459&scoped=true&"
import script from "./TotpVerify.vue?vue&type=script&lang=js&"
export * from "./TotpVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b665459",
  null
  
)

export default component.exports